<template>
  <div>
    <div class="modal">
      <div class="modal__title" v-if="type == 'valid'">
        Je valide<br>mon prochain réappro ?
      </div>
      <div class="modal__title" v-else-if="type == 'param'">
        Je sauvegarde<br>mon réappro ?
      </div>
      <div class="modal__title" v-else-if="type == 'cancel-param'">
        J'annule<br>mes modifications
      </div>
      <div class="modal__title" v-else-if="type == 'refuse'">
        Je refuse<br>mon prochain réappro ?
      </div>
      <div class="modal__title" v-else-if="type == 'valid-recept'">
        Je valide<br>la réception de mon réappro
      </div>
      <div class="modal__picto">
        <img src="/static/img/pictos/reapprobleufonce-valid.svg">
      </div>
      <div class="modal__btns">
        <a href="" v-if="type == 'valid'" class="modal__btn modal__btn--valid" @click.prevent="validReappro(id)">
          <span>Oui</span>
          <img src="/static/img/pictos/valider.svg" class="">
        </a>
        <a href="" v-else-if="type == 'param'" class="modal__btn modal__btn--valid" @click.prevent="validReapproParams()">
          <span>Oui</span>
          <img src="/static/img/pictos/valider.svg" class="">
        </a>
        <a href="" v-else-if="type == 'cancel-param'" class="modal__btn modal__btn--valid" @click.prevent="cancelReapproParams()">
          <span>Oui</span>
          <img src="/static/img/pictos/valider.svg" class="">
        </a>
        <a href="" v-else-if="type == 'refuse'" class="modal__btn modal__btn--valid" @click.prevent="refuseReappro(id)">
          <span>Oui</span>
          <img src="/static/img/pictos/valider.svg" class="">
        </a>
        <a href="" v-else-if="type == 'valid-recept'" class="modal__btn modal__btn--valid" @click.prevent="validReceptReapproParams(id)">
          <span>Oui</span>
          <img src="/static/img/pictos/valider.svg" class="">
        </a>
        <a href="" class="modal__btn modal__btn--delete" @click.prevent="closeModal()">
          <span>Non</span>
          <img src="/static/img/pictos/supprimer.svg" class="">
        </a>
      </div>
    </div>
    <div class="overlay" @click.prevent="closeModal()">
      <i></i>
    </div>
  </div>
</template>

<script>


export default {
  name: "ReapproModal",
  props: [
    "type",
    "id",
    "items",
    "item"
  ],
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  mounted() {

  },
  created(){
  },
  methods: {
    closeModal(){
      this.$emit("close")
    },
    validReappro(id){
      this.$http.patch('order/reappro/valid/'+id, {
        status: 1,
        item: this.item
      }, {
        redirectOnSuccess: {name: 'ReapproList'}
      })
    },
    refuseReappro(id){
      this.$http.patch('order/reappro/refuse/'+id, {
        status: 9,
      }, {
        redirectOnSuccess: {name: 'ReapproList'}
      })
    },
    validReapproParams(){
      const self = this;
      this.$http.post('vehiclestock/save/all', {
        items: this.items
      }).then(function(){
        self.closeModal();
        self.$emit("reload")
      })
    },
    cancelReapproParams(){
      let items = this.items[0];
      const self = this;
      self.closeModal();
      self.$emit("reload")
    },
    validReceptReapproParams(id){
      this.$http.patch('order/valid-recept/'+id, {
        status: 4,
        item: this.item
      }, {
        redirectOnSuccess: {name: 'ReapproList'}
      })
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: white;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: white;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(25, 45, 85, 0.95);
    z-index: 800;
  }

  .modal { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: white; height: 320px; width: 320px; z-index: 900; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center;
    &__title{ font-family: 'ClanFFBlack'; font-size: 20px; color: $color1; margin-top: auto; }
    &__picto{ width: 120px; margin-top: 20px; margin-bottom: auto; }
    &__btns{ display: flex; height: 50px; width: 100%; margin-bottom: -1px; }
    &__btn{ width: 50%; height: 100%; display: flex; align-items: center; justify-content: center;
      img{ width: 30px; }
      span{ font-family: 'ClanProBold'; font-size: 14px; color: white; text-transform: uppercase; margin-right: 10px; }
      &--valid{ background-color: $vert;  }
      &--delete{ background-color: $color1;  }
      &:hover{ text-decoration: none; }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproModal.vue